export function createComparableTailoredTask(task, tailoredValues = {}) {
    return {
        classification: tailoredValues.classification ?? task.classification,
        frequency: tailoredValues.frequency ?? task.frequency,
        minutes: tailoredValues.minutes ?? task.minutes,
        included: tailoredValues.included ?? task.included,
        skill: tailoredValues.skill ?? task.skill,
    }
}
